import { render, staticRenderFns } from "./EditFood.vue?vue&type=template&id=56b9308c&scoped=true&"
import script from "./EditFood.vue?vue&type=script&lang=js&"
export * from "./EditFood.vue?vue&type=script&lang=js&"
import style0 from "./EditFood.vue?vue&type=style&index=0&id=56b9308c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b9308c",
  null
  
)

export default component.exports